import Image from 'next/image'
import { Column, Grid } from './Grid'
import { Headline } from './Headline'
import { Button } from './Button'
import { Arrow } from './Arrow'
import { Trustpilot } from './Trustpilot'

import hero from '@/public/images/hero.png'
import avatars from '@/public/images/avatars.png'
import harvard_icon from '@/public/images/harvard_icon.png'
import nyu_icon from '@/public/images/nyu_icon.png'
import { imageLoader } from '@/loaders/index'
import { useQuery } from '@/utils/url'
import { useSelector } from 'react-redux'

export function HeroSection({
  className = ''
}) {
  const checkoutState = useSelector((state) => state.checkout)
  const checkoutLink = useQuery('/checkout', { type: 'productivity-course' })

  return (
    <section className={`${className}`}>
      <Grid className='justify-between flex-col md:flex-row'>
        <Column className='md:w-[50%]'>
          <Headline tag='h1' className='text-[40px] md:text-[60px] leading-[1.15] mb-[30px] md:mb-[50px]' weight={600}>
            Achieve Your Business Goals 10x Faster With Scientific Productivity
          </Headline>
          <p className='text-[18px] max-w-[430px] mb-[30px] md:mb-[90px] font-thin leading-[1.6]'>
            The complete evidence-based course on smart planning & effortless execution for entrepreneurs who want to <b className='font-bold'>move fast</b> and <b className='font-bold'>hit their biggest goals</b>.
          </p>
        </Column>
        <Column className='md:w-[46%]'>
          <div className='md:mr-[-60px] ml-[-30px] mr-[-30px] md:ml-0 md:mr-0'>
            <Image
              src={hero}
              priority
              alt="course materials"
              loader={imageLoader}
            />
          </div>
        </Column>
      </Grid>
      <Grid className='justify-between flex-col md:flex-row md:items-end'>
        <Column className='md:w-[40%]'>
          {checkoutState.coupon.available && checkoutState.coupon.finalPrice && checkoutState.coupon.initialPrice &&
            <Button href={checkoutLink} radius={0} size="large" className="w-full md:w-[340px] px-[40px] py-[15px]" uppercase={false}><span className="text-[18px]">Get Instant Access <span className='line-through'>${checkoutState.coupon.initialPrice}</span> ${checkoutState.coupon.finalPrice}</span><Arrow className="ml-[16px] rotate-[-45deg]"/></Button>
          }
          {!checkoutState.coupon.available &&
            <Button href={checkoutLink} radius={0} size="large" className="w-full md:w-[340px] px-[40px] py-[15px]" uppercase={false}><span className="text-[18px]">Get Instant Access $97</span></Button>
          }
        </Column>
        <Column className='md:w-[40%]'>
          <div className='flex justify-between items-center flex-col md:flex-row mt-[46px]'>
            <div className='text-center md:text-left'>
              <Headline tag='h5' className='text-[15px] mb-[12px] leading-[1]'>Join 8000+ Entrepreneurs</Headline>
              <div className='w-[225px] md:w-[185px]'>
                <Image
                  src={avatars}
                  priority
                  alt="customers photos"
                  loader={imageLoader}
                />
              </div>
            </div>
            <div className='mt-[30px] md:mt-0'>
              <Trustpilot numberOfReviews={process.env.NEXT_PUBLIC_TRUSTPILOT_REVIEWS_COUNT} rating={4.6}/>
            </div>
          </div>
        </Column>
      </Grid>
      <Grid className='justify-between mt-[90px] md:mt-[160px] flex-col md:flex-row'>
        <Column className='md:w-[40%]'>
          <Headline tag='h3' className='text-[24px] md:text-[34px] mb-[30px] md:mb-[60px] leading-[1.2]'>Science-Backed With Researchers From:</Headline>
          <div className='flex w-full justify-between md:justify-start border-b border-black pt-[20px] h-[180px] md:h-[200px]'>
            <div className='w-[40%] md:w-[50%]'>
              <Image
                className='opacity-[0.7]'
                src={harvard_icon}
                alt='Harvard Icon'
                loader={imageLoader}
                width={70}
                height={70}
                priority
              />
              <p className='mt-[30px] font-thin'>Harvard University</p>
            </div>
            <div className='w-[40%] md:w-[50%]'>
              <Image
                className='opacity-[0.7]'
                src={nyu_icon}
                loader={imageLoader}
                alt='NYU Icon'
                width={70}
                height={70}
                priority
              />
              <p className='mt-[30px] font-thin'>New York University</p>
            </div>
          </div>
        </Column>
        <Column className='md:w-[40%] mt-[70px] md:mt-0'>
          <Headline tag='h3' className='text-[24px] md:text-[34px] mb-[30px] md:mb-[60px] leading-[1.2]'>Field-Tested With <br/> Thousands of Entrepreneurs:</Headline>
          <div className='flex flex-col border-b border-black h-[180px] md:h-[200px]'>
            <div className='flex mb-[20px] justify-between md:flex-start'>
              <span className='w-[40%] md:w-[50%] text-[34px] leading-[1]'>
                8500+
              </span>
              <span className='w-[40%] md:w-[50%] leading-[1.2] font-thin'>
                Entrepreneur <br/> Clients
              </span>
            </div>
            <div className='flex mb-[20px] justify-between md:flex-start'>
              <span className='w-[40%] md:w-[50%] text-[34px] leading-[1]'>
                193,000+
              </span>
              <span className='w-[40%] md:w-[50%] leading-[1.2] font-thin'>
              Coaching <br/> Calls
              </span>
            </div>
            <div className='flex justify-between md:flex-start'>
              <span className='w-[40%] md:w-[50%] text-[34px] leading-[1]'>
                10+
              </span>
              <span className='w-[40%] md:w-[50%] leading-[1.2] font-thin'>
              Years <br/> in Business
              </span>
            </div>
          </div>
        </Column>
      </Grid>
    </section>
  )
}
